
class BaseAPI {

    static setToken = (newToken) => {

        localStorage.setItem('gip_token', newToken);

    }
    
    static getToken = () => {

        return localStorage.getItem('gip_token');

    }

    static handleResponse = (response) => {
        if (response.headers.has('gluinv-validUntil')) {
            localStorage.setItem('gluinv-validUntil', response.headers.get('gluinv-validUntil'));
            dispatchEvent(new Event('gluinv-validUntil'));
            return response.text().then(txt => {
                const data = txt && JSON.parse(txt);
                
                if (!response.ok) {
                    const error = data;
                    return Promise.reject(error);
                }

                return data;
            });            
        }
    }

    static get_API_BASE_URL = () => {
        if (window.location.host.indexOf('glucroft-portal-web-dev') > -1)
            return process.env.REACT_APP_API_URL_DEV
        else if (window.location.host.indexOf('glucroft-portal-web-uat') > -1)
            return process.env.REACT_APP_API_URL_UAT
        else
            return process.env.REACT_APP_API_URL;
    }


    static getRequest = async (endpoint, method = 'GET', token='') => {

        let headers = {
            'Content-type': 'application/json; charset=utf-8',
            'Authorization': 'Bearer ' + ((token) ? token : this.getToken())
        };

        const request = new Request(`${this.get_API_BASE_URL() + endpoint}`, {
            //    credentials: "include",
            method: method,
            headers: headers
        });

        return await fetch(request).then(this.handleResponse);
    }

    static postRequest = async (endpoint, requestObject, token='') => {

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=utf-8',
            'Authorization': 'Bearer ' + ((token) ? token : this.getToken())
        };

        const request = new Request(`${this.get_API_BASE_URL() + endpoint}`, {
            //    credentials: "include",
            method: 'POST',
            headers: headers,
            body: JSON.stringify(requestObject)
        });

        return await fetch(request).then(this.handleResponse);
    }


    static putRequest = async (endpoint, requestObject, token='') => {

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=utf-8',
            'Authorization': 'Bearer ' + ((token) ? token : this.getToken())
        };

        const request = new Request(`${this.get_API_BASE_URL() + endpoint}`, {
            //    credentials: "include",
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(requestObject)
        });

        return await fetch(request).then(this.handleResponse);
    }


    static deleteRequest = async (endpoint, method = 'DELETE', token='') => {
        let headers = {
            'Content-type': 'application/json; charset=utf-8',
            'Authorization': 'Bearer ' + ((token) ? token : this.getToken())
        };

        const request = new Request(`${this.get_API_BASE_URL() + endpoint}`, {
            method: method,
            headers: headers
        });

        return await fetch(request).then(this.handleResponse);
    }


    static uploadFile = async (endpoint, requestObject, token='') => {

        let headers = {
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + ((token) ? token : this.getToken())
        };

        const request = new Request(`${this.get_API_BASE_URL() + endpoint}`, {
            //    credentials: "include",
            method: 'POST',
            headers: headers,
            body: requestObject
        });

        return await fetch(request).then(this.handleResponse);
    }

    static requestReport = async (endpoint, requestObject, token='') => {

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=utf-8',
            'Authorization': 'Bearer ' + ((token) ? token : this.getToken())
        };

        const request = new Request(`${this.get_API_BASE_URL() + endpoint}`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(requestObject)
        });

        return await fetch(request).then(this.handleResponse);
    }

    static downloadFile = async (endpoint) => {
        const url = this.get_API_BASE_URL() + endpoint;
        const token = this.getToken();

        const response = await fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Download failed: ${response.status}`);
        }

        const filename = this.getFilenameFromResponse(response) || 'download';
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);
    }

    static getFilenameFromResponse = (response) => {
        const disposition = response.headers.get('Content-Disposition');
        if (!disposition) return null;

        // Handles both filename="foo.pdf" and filename*=UTF-8''foo.pdf
        const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (utf8Match) {
            return decodeURIComponent(utf8Match[1]);
        }

        const asciiMatch = disposition.match(/filename="?([^";]+)"?/i);
        if (asciiMatch) {
            return asciiMatch[1];
        }

    return null;
};
};

export default BaseAPI;
